export default __webpack_public_path__ + "static/char-s-59-zh-Hans-60006edad8e7b69201527cd5cacbd6af.webp";